<div class="input-dialog">
  <button
    class="close-button"
    mat-icon-button
    type="button"
    (click)="handleCancel()">
    <mat-icon>close</mat-icon>
  </button>

  <div class="title">{{ data.title }}</div>

  @if (data.description) {
    <div class="description">
      {{ data.description }}
    </div>
  }

  <mat-form-field
    class="input-field input-40"
    appearance="outline">
    <input
      matInput
      autocomplete="off"
      cdkFocusInitial
      [placeholder]="data.placeholder ?? ''"
      [formControl]="inputControl"
      (keydown.enter)="handleConfirm()" />
  </mat-form-field>

  <div class="buttons">
    <button
      mat-button
      type="button"
      color="primary"
      (click)="handleCancel()">
      {{ data.cancelLabel ?? 'INPUT_DIALOG.CANCEL' | translate }}
    </button>
    <button
      mat-raised-button
      type="button"
      color="primary"
      [disabled]="inputControl.invalid"
      (click)="handleConfirm()">
      {{ data.confirmLabel ?? 'INPUT_DIALOG.OK' | translate }}
    </button>
  </div>
</div>
